/**
 * ISC License
 *
 * Copyright (c) 2018, Aleck Greenham
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

import PropTypes from "prop-types";
import React, { Component, PureComponent } from "react";
import isEqual from "lodash.isequal";
import ReactDOM from "react-dom";
import isBool from "lodash.isboolean";
import isObject from "lodash.isobject";
var classCallCheck = function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
  createClass = function () {
    function e(e, t) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    return function (t, o, n) {
      return o && e(t.prototype, o), n && e(t, n), t;
    };
  }(),
  _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  },
  inherits = function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  },
  objectWithoutProperties = function (e, t) {
    var o = {};
    for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (o[n] = e[n]);
    return o;
  },
  possibleConstructorReturn = function (e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  },
  FocusTrap = function (e) {
    function t() {
      return classCallCheck(this, t), possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
    }
    return inherits(t, Component), createClass(t, [{
      key: "render",
      value: function () {
        var e = this.props,
          t = e.component,
          o = e.children,
          n = objectWithoutProperties(e, ["component", "children"]);
        return /*#__PURE__*/React.createElement(t, _extends({
          tabIndex: "-1"
        }, n), o);
      }
    }]), t;
  }();
function sequencesFromKeyMap(e, t) {
  var o = e[t];
  return o ? Array.isArray(o) ? o : [o] : [t];
}
function hasChanged(e, t) {
  return !isEqual(e, t);
}
FocusTrap.defaultProps = {
  component: "div"
};
var HotKeys = function (e) {
  function t(e, o) {
    classCallCheck(this, t);
    var n = possibleConstructorReturn(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, o));
    return n.onFocus = n.onFocus.bind(n), n.onBlur = n.onBlur.bind(n), n;
  }
  return inherits(t, Component), createClass(t, [{
    key: "getChildContext",
    value: function () {
      return {
        hotKeyParent: this,
        hotKeyMap: this.__hotKeyMap__
      };
    }
  }, {
    key: "componentWillMount",
    value: function () {
      this.updateMap();
    }
  }, {
    key: "updateMap",
    value: function () {
      var e = this.buildMap();
      return !isEqual(e, this.__hotKeyMap__) && (this.__hotKeyMap__ = e, !0);
    }
  }, {
    key: "buildMap",
    value: function () {
      var e = this.context.hotKeyMap || {},
        t = this.props.keyMap || {};
      return _extends({}, e, t);
    }
  }, {
    key: "getMap",
    value: function () {
      return this.__hotKeyMap__;
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var e = require("mousetrap");
      this.__mousetrap__ = new e(this.props.attach || ReactDOM.findDOMNode(this)), this.updateHotKeys(!0);
    }
  }, {
    key: "componentDidUpdate",
    value: function (e) {
      this.updateHotKeys(!1, e);
    }
  }, {
    key: "componentWillUnmount",
    value: function () {
      this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null), this.__mousetrap__ && this.__mousetrap__.reset();
    }
  }, {
    key: "updateHotKeys",
    value: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        o = this.props.handlers,
        n = void 0 === o ? {} : o,
        r = t.handlers,
        s = void 0 === r ? n : r,
        a = this.updateMap();
      (e || a || hasChanged(n, s)) && (this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null), this.syncHandlersToMousetrap());
    }
  }, {
    key: "syncHandlersToMousetrap",
    value: function () {
      var e = this,
        t = this.props.handlers,
        o = void 0 === t ? {} : t,
        n = this.getMap(),
        r = [],
        s = this.__mousetrap__;
      Object.keys(o).forEach(function (t) {
        var s = o[t];
        sequencesFromKeyMap(n, t).forEach(function (t) {
          var o = void 0;
          isObject(t) && (o = t.action, t = t.sequence), r.push({
            callback: function (t, o) {
              if ((isBool(e.props.focused) ? e.props.focused : e.__isFocused__) && o !== e.__lastChildSequence__) return e.context.hotKeyParent && e.context.hotKeyParent.childHandledSequence(o), s(t, o);
            },
            action: o,
            sequence: t
          });
        });
      }), s.reset(), r.forEach(function (e) {
        var t = e.sequence,
          o = e.callback,
          n = e.action;
        return s.bind(t, o, n);
      });
    }
  }, {
    key: "childHandledSequence",
    value: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
      this.__lastChildSequence__ = e, this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(e);
    }
  }, {
    key: "render",
    value: function () {
      var e = this.props,
        t = (e.keyMap, e.handlers, e.focused, e.attach, e.children),
        o = objectWithoutProperties(e, ["keyMap", "handlers", "focused", "attach", "children"]);
      return /*#__PURE__*/React.createElement(FocusTrap, _extends({}, o, {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }), t);
    }
  }, {
    key: "onFocus",
    value: function () {
      var e;
      (this.__isFocused__ = !0, this.props.onFocus) && (e = this.props).onFocus.apply(e, arguments);
    }
  }, {
    key: "onBlur",
    value: function () {
      var e;
      (this.__isFocused__ = !1, this.props.onBlur) && (e = this.props).onBlur.apply(e, arguments);
      this.context.hotKeyParent && this.context.hotKeyParent.childHandledSequence(null);
    }
  }]), t;
}();
HotKeys.childContextTypes = {
  hotKeyParent: PropTypes.any,
  hotKeyMap: PropTypes.object
}, HotKeys.contextTypes = {
  hotKeyParent: PropTypes.any,
  hotKeyMap: PropTypes.object
};
var withHotKeys = function (e) {
  return function (t) {
    return function (o) {
      function n(e) {
        classCallCheck(this, n);
        var t = possibleConstructorReturn(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
        return t._setRef = t._setRef.bind(t), t.state = {
          handlers: {}
        }, t;
      }
      return inherits(n, PureComponent), createClass(n, [{
        key: "componentDidMount",
        value: function () {
          this.setState({
            handlers: this._ref.hotKeyHandlers
          });
        }
      }, {
        key: "_setRef",
        value: function (e) {
          this._ref = e;
        }
      }, {
        key: "render",
        value: function () {
          var o = this.state.handlers;
          return /*#__PURE__*/React.createElement(HotKeys, {
            component: "document-fragment",
            keyMap: e,
            handlers: o
          }, /*#__PURE__*/React.createElement(t, _extends({
            ref: this._setRef
          }, this.props)));
        }
      }]), n;
    }();
  };
};
function HotKeyMapMixin() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return {
    contextTypes: {
      hotKeyMap: PropTypes.object
    },
    childContextTypes: {
      hotKeyMap: PropTypes.object
    },
    getChildContext: function () {
      return {
        hotKeyMap: this.__hotKeyMap__
      };
    },
    componentWillMount: function () {
      this.updateMap();
    },
    updateMap: function () {
      var e = this.buildMap();
      return !isEqual(e, this.__hotKeyMap__) && (this.__hotKeyMap__ = e, !0);
    },
    buildMap: function () {
      var t = this.context.hotKeyMap || {},
        o = this.props.keyMap || {};
      return _extends({}, t, e, o);
    },
    getMap: function () {
      return this.__hotKeyMap__;
    }
  };
}
export { HotKeys, withHotKeys, FocusTrap, HotKeyMapMixin };